<template>
  <q-layout>
    <q-page-container style="overflow: unset; position: static;">
      <q-page style="overflow: unset; position: static; min-height: unset;">
        <div @contextmenu="addContextMenuItems({items:defaultContextMenuItems, priority: 0, $event})">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'EmbeddedLayout',
    data() {
        return {
            defaultContextMenuItems: [
                { label: 'Apps View', action: () => { this.$router.push(this.$route.path.replace(/^\/embedded\//, '/apps/')) } },
            ], 
        }
    },
    mounted() {
        this.$el.removeAttribute('tabindex')
    },  
    computed: {
        ...mapGetters(['user']),
    },
    methods: {
        ...mapActions(['addContextMenuItems']),
        
    },
}
</script>